module.exports = __webpack_public_path__ + "img/plate-green.771ac44b.svg";